import { Link as AriaLink } from "react-aria-components";
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  useLocation,
} from "react-router";
import { getLanguageFromPath, isLocalizedPath } from "../../../utils/language";
import {
  InternalLinkProps,
  InternalNavLinkProps,
  LinkProps,
  SharedLinkProps,
} from "../types";
import { localizeTo } from "../utils";

/** Router Link that prefixes paths with the current language when already on a localized path. */
export const InternalLink = ({
  to,
  ...rest
}: InternalLinkProps & SharedLinkProps) => {
  const { pathname } = useLocation();
  const localizedTo = isLocalizedPath(pathname)
    ? localizeTo(to, getLanguageFromPath(pathname))
    : to;

  return <RouterLink to={localizedTo} {...rest} />;
};

/** Router NavLink that prefixes paths with the current language when already on a localized path. */
export const InternalNavLink = ({ to, ...rest }: InternalNavLinkProps) => {
  const { pathname } = useLocation();
  const localizedTo = isLocalizedPath(pathname)
    ? localizeTo(to, getLanguageFromPath(pathname))
    : to;

  return <RouterNavLink to={localizedTo} {...rest} />;
};

const BaseLink = (props: LinkProps) => {
  if ("href" in props) {
    return <AriaLink {...props} />;
  }

  return <InternalLink {...props} />;
};

export default BaseLink;
